export const SupplierDetailsTab = {
  CONTACTS: 'CONTACTS',
  FILES: 'FILES',
  MAIN: 'MAIN',
  TASKS: 'TASKS',
} as const;

export type SupplierDetailsTab = (typeof SupplierDetailsTab)[keyof typeof SupplierDetailsTab];
